import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import baseURL from '../Common/Config';
import Axiosfetch from '../Common/Axiosfetch';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import FailureAlert from '../Common/Failure';
import * as yup from 'yup';

const Product = {
    Name: "",
    Description: "",
    Price: 0,
    Units: "",
    Gst: 0,
    HSNCode: "",
    Margin: 0
};

const ProductSchema = yup.object().shape({
    Margin: yup.number().required().min(0.1),
    Gst: yup.number().required().min(0.1),
    Price: yup.number().required().min(1),
    Name: yup.string().trim().required()
});

const AddProduct = ({ themecolor, hideproduct, getProduct, regionDetails, edit, productdetail, allProduct }) => {

    const [productData, setProductData] = useState(Product);

    const onTextChange = (e) => {
        let value = e.target.value;
        setProductData({ ...productData, [e.target.name]: value });
    };

    const onNumberChange = (e) => {
        let value = e.target.value === "" ? 0 : parseFloat(e.target.value);
        setProductData({ ...productData, [e.target.name]: value });
    };

    const SaveProductDetails = (product) => {
        ProductSchema.validate(product).then(valid => {
            if (ValidateProduct(product)) {
                Axiosfetch(baseURL + ((parseInt(edit) === 0) ? "CreateProduct" : "EditProduct"), "POST", product, ProductDetailsSuccess, Failure);
            }
        }).catch(err => {
            Alert.error(err.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        });
    };

    const ProductDetailsSuccess = (data) => {
        Alert.success(data, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });
        hideproduct();
        getProduct();
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    const ValidateProduct = (product) => {
        var errorMsg = "";
         if (product.Name.trim() !== "") {
            var namedata = allProduct.filter(c => c.Name.trim().toLowerCase() === product.Name.trim().toLowerCase());
            if (namedata.length > 0) {
                if (product.ID === undefined) {
                    errorMsg = "Name Already Exist.";
                }
                if (namedata[0].ID !== product.ID) {
                    errorMsg = "Name Already Exist.";
                }
            }
        }

        if (errorMsg !== "") {
            Alert.error(errorMsg, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
            return false;
        }

        return true;
    };

    useEffect(() => {
        if (parseInt(edit) === 1) {
            setProductData(productdetail);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <div id="addProduct" className="modal" style={{ display: "block" }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${themecolor}`}>
                    <span style={{ marginLeft: "5px", padding:"5px" }}>{parseInt(edit) === 0 ? "Add" : "Edit"} Product</span>
                        <span className="close" onClick={hideproduct}>&times;</span>
                    </div>

                    <table className="table">
                        <tbody>
                            <tr>
                                <td>
                                    <h5>Name<span className="mandatoryStar">*</span></h5>
                                </td>
                                <td>
                                    <input type="text" name="Name"
                                        className="form-control"
                                        onChange={e => onTextChange(e)}
                                        value={productData.Name}></input>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h5>Description</h5>
                                </td>
                                <td>
                                    <textarea
                                        onChange={e => onTextChange(e)}
                                        rows="1"
                                        className="form-control" name="Description" value={productData.Description}></textarea>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h5>Price<span className="mandatoryStar">*</span></h5>
                                </td>
                                <td>
                                    <input type="number" min="0.00" step="any" name="Price"
                                        className="form-control"
                                        onChange={e => onNumberChange(e)}
                                        value={productData.Price}></input>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <h5>Units</h5>
                                </td>
                                <td>
                                    <input type="text" name="Units"
                                        className="form-control"
                                        onChange={e => onTextChange(e)}
                                        value={productData.Units}></input>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h5>{regionDetails.TaxSystem !== undefined ? regionDetails.TaxSystem : "GST"}<span className="mandatoryStar">*</span></h5>
                                </td>
                                <td>
                                    <input type="number" name="Gst" min="0.00" step="0.1"
                                        className="form-control"
                                        onChange={e => onNumberChange(e)}
                                        value={productData.Gst}></input>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h5>HSN Code</h5>
                                </td>
                                <td>
                                    <input type="text" name="HSNCode"
                                        className="form-control"
                                        onChange={e => onTextChange(e)}
                                        value={productData.HSNCode}></input>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h5>Margin (%)<span className="mandatoryStar">*</span></h5>
                                </td>
                                <td>
                                    <input type="text" name="Margin"
                                        className="form-control"
                                        onChange={e => onNumberChange(e)}
                                        value={productData.Margin}></input>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="2" style={{ textAlign: "right" }}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${themecolor}Focus`} onClick={() => SaveProductDetails(productData)}>Save</button>
                                            <button type="button" className="btn btn-default" onClick={hideproduct}>Close</button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default AddProduct;